import state from './moduleCommunityState.js'
import mutations from './moduleCommunityMutations.js'
import actions from './moduleCommunityActions.js'
import getters from './moduleCommunityGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
